export default "__VITE_ASSET__88pcliPH__"